module.exports = __webpack_public_path__ + "img/game_img1.38821d86.jpg";